import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import {ch4_p02} from "../../../layouts/ch4_p02/ch4_p02"

export class Chapter4Page2 extends AbstractStoryState {

    readonly bg = this.addChild(new SceneSprite());
    readonly holly = list(()=>this.addChild(new SceneSprite()));
    readonly guitarStand = this.addChild(new SceneSprite());
    readonly basket = this.addChild(new SceneSprite());

	readonly frameLeft = this.addChild(new SceneSprite());
	readonly frameRight = this.addChild(new SceneSprite());
    readonly linesRight = this.addChild(new SceneSprite());
    readonly linesLeft = this.addChild(new SceneSprite());

    dontScaleUp = true;

    public init(pSize: PIXI.Point, pData: any) {
		// exported layouts from Animate CC
        ch4_p02.call(this);

        this.holly[0].visible = true;
        this.holly[1].visible = false;
        this.holly[2].visible = false;

		// super.init calls onResize
		super.init(pSize, pData);
	}

	public update(pDeltaTime: number) {
		super.update(pDeltaTime);
	}

	public animateIn(pOnComplete: ()=>void) {
        super.animateIn(pOnComplete);
    }

    public animateOut(pOnComplete: ()=>void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        new TimelineLite()
            .call(()=>{
                this.holly[0].FadeOut();
                this.holly[1].FadeIn();
                this.showHint(this.basket, "hand", 8);
            }, undefined, undefined, 1.5)
            .call(()=>{
                this.holly[1].FadeOut();
                this.holly[2].FadeIn();
            }, undefined, undefined, 3)
            .call(()=>{
                super.onAnimateInComplete();
            }, undefined, undefined, "+=1.5")
            .call(()=>{
                this.gotoNextState({transition: "fade"});
            }, undefined, undefined, "+=1.5")
        ;
    }
}